import { ReportsGroupBy, StructuralPassFailRow } from '@models/interfaces';

import themeColors from 'styles/theme/colors.module.scss';

export type StructuralStatus = StructuralPassFailRow['structuralStatus'];
export type StructuralPassFailGroupKey = Extract<
  StructuralStatus,
  'fail' | 'pass'
>;
export type StructuralPassFailGroupBy =
  | ReportsGroupBy.ProjectType
  | ReportsGroupBy.State
  | ReportsGroupBy.Submarket;

export const STRUCTURAL_STATUS_LABELS: Record<StructuralStatus, string> = {
  fail: 'Fail',
  pass: 'Pass',
  pending: 'Pending',
};

export const STRUCTURAL_STATUS_COLORS: Record<StructuralStatus, string> = {
  fail: themeColors.danger,
  pass: themeColors.turquoise,
  pending: themeColors.yellow,
};

export const STRUCTURAL_ANALYSIS_STATUS_ORDER: StructuralStatus[] = [
  'pass',
  'fail',
  'pending',
];

export const STRUCTURAL_PASS_FAIL_GROUP_KEYS: StructuralPassFailGroupKey[] = [
  'pass',
  'fail',
];

export const STRUCTURAL_PASS_FAIL_GROUP_BY_VALUES: StructuralPassFailGroupBy[] =
  [ReportsGroupBy.ProjectType, ReportsGroupBy.Submarket, ReportsGroupBy.State];

export const STRUCTURAL_PASS_FAIL_GROUP_TITLE_BY_GROUP_BY: Record<
  StructuralPassFailGroupBy,
  string
> = {
  [ReportsGroupBy.ProjectType]: 'Project Type',
  [ReportsGroupBy.State]: 'State',
  [ReportsGroupBy.Submarket]: 'Submarket',
};
